import React from 'react'
import { Link, NavLink } from 'react-router'
import { Stack, TableCell, TableRow } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { formatBigMoney, formatDateYYYYMMDD } from '../../../../packages/utils/numberFormatters'
import { formatWarrantSubPrice } from '../../../../components/entities/WarrantSubPrice'
import { HasWarrantLabel } from '../../../../components/entities/IssueTypeLabels'
import { WarrantEntity } from 'types/WarrantEntity'
import { getAmountForPriceAtDate, hasSubPeriodPrelPrice } from '../../../../utils/warrants'
import { normalizedWarrantName } from '@finance-lab/utils/shared'

type WarrantObject = {
    type: 'issue'
    subStartDate: string
    subEndDate: string
    item: WarrantEntity
}

export const WarrantTableRow = ({
    obj,
    locale,
    isLargeScreen,
    multipleInstrumentsExists = false,
}: {
    obj: WarrantObject
    locale: string
    isLargeScreen: boolean
    multipleInstrumentsExists: boolean
}) => {
    const { t } = useTranslation()
    const warrant = obj.item

    const period =
        obj.subStartDate && obj.subEndDate
            ? `${formatDateYYYYMMDD(obj.subStartDate, { locale })} - ${formatDateYYYYMMDD(obj.subEndDate, { locale })}`
            : t('site.missing')

    const { subscriptionPeriods, totalNumberOfWarrants } = warrant

    const { warrantSubPrice, prelSubPrice, subStartDate } = warrant.currentSubscriptionPeriod
    const showPrelPrice = hasSubPeriodPrelPrice(warrant.currentSubscriptionPeriod)
    const price = showPrelPrice ? prelSubPrice : warrantSubPrice
    const amount =
        subStartDate === null
            ? null
            : getAmountForPriceAtDate(
                  price,
                  totalNumberOfWarrants,
                  subscriptionPeriods,
                  new Date(subStartDate).toISOString(),
              )
    return (
        <TableRow>
            {multipleInstrumentsExists && isLargeScreen ? <TableCell>{warrant.instrumentSymbol}</TableCell> : null}
            <TableCell>
                <Stack
                    direction={{ sx: 'column', sm: 'row' }}
                    spacing={2}
                    sx={{
                        alignItems: { xs: 'start', sm: 'center' },
                    }}
                >
                    <HasWarrantLabel />
                    <Link component={NavLink} to={`/warrants/${warrant.id}`}>
                        {normalizedWarrantName(warrant)}
                    </Link>
                </Stack>
            </TableCell>
            <TableCell>{period}</TableCell>
            <TableCell>{formatWarrantSubPrice(warrant, locale)}</TableCell>
            {isLargeScreen ? (
                <TableCell>
                    <>
                        {amount
                            ? formatBigMoney(amount, {
                                  currencySymbol: warrant.currency,
                                  decimals: 0,
                                  locale,
                                  tooltip: true,
                              })
                            : '-'}
                        {showPrelPrice && '*'}
                    </>
                </TableCell>
            ) : null}
        </TableRow>
    )
}
